import _extends from "@babel/runtime/helpers/extends";
import { DonationCard as Base } from "@cancer-council-queensland/react";
import { cleanHref } from "../lib";
import { jsx as _jsx } from "react/jsx-runtime";
export var DonationCard = props => {
  var _props$prices, _props$prices$split;

  return /*#__PURE__*/_jsx(Base, _extends({}, props, {
    prices: (_props$prices = props.prices) == null ? void 0 : (_props$prices$split = _props$prices.split(",")) == null ? void 0 : _props$prices$split.map(x => parseInt(x)),
    thank_you: cleanHref(props.thank_you)
  }));
};
//# sourceMappingURL=donation_card.js.map